var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.568651 7.21875C0.519772 7.39077 0.183724 7.55676 0.165395 7.71671C0.0981855 8.33539 2.6613 9.62404 5.00446 9.62404C7.34762 9.62404 9.90768 8.34444 9.84658 7.73783C9.83131 7.57185 9.49221 7.39983 9.44027 7.22177L0.568651 7.21875Z",
    fill: "url(#paint0_linear_9478_22064)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.650515 7.8321C1.02628 7.97093 1.88167 8.51114 5.00079 8.51114C8.11991 8.51114 8.9753 7.96791 9.35106 7.8321C10.1667 7.53333 10.0201 6.04247 9.35106 6.16319C8.8806 6.24769 6.38469 6.75168 5.00384 6.75168C3.623 6.75168 0.736054 6.16319 0.736054 6.16319C-0.0582371 6.12999 -0.17127 7.50013 0.656625 7.8321H0.650515Z",
    fill: "url(#paint1_radial_9478_22064)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.656688 6.16211C0.656688 6.16211 1.72898 6.37336 2.88376 6.54539C4.19129 7.10371 4.39902 8.07246 4.39902 8.07246C2.53244 6.92263 1.4632 6.94979 1.27379 6.88641C0.705567 6.69628 -0.128438 7.40852 1.66483 7.98796C2.65158 8.30485 4.01715 8.35615 5.00391 8.35615L5.00085 8.51006C1.88173 8.51006 1.02634 7.96985 0.650578 7.83103H0.656688C0.283982 7.68013 0.0854087 7.321 0.0548592 6.97393C0.0731888 6.54539 0.277872 6.16513 0.656688 6.16211Z",
    fill: "url(#paint2_linear_9478_22064)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.311654 7.5799C0.75768 7.7489 1.76276 8.30722 4.97659 8.30722C8.37066 8.30722 9.29937 7.69156 9.71179 7.55273H9.71484C9.62625 7.67647 9.50711 7.77304 9.3513 7.83039C8.97554 7.96921 8.12015 8.50943 5.00103 8.50943C1.88191 8.50943 1.02652 7.96921 0.650756 7.83039H0.656866C0.513283 7.77606 0.400249 7.68854 0.311654 7.5799Z",
    fill: "url(#paint3_linear_9478_22064)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00451 8.35666C5.99126 8.35666 7.36905 8.33554 8.34359 7.98847C9.77331 7.48146 9.1226 6.6968 8.92403 6.66662C8.72546 6.63644 8.28249 6.74207 7.61039 7.08913C6.9383 7.43619 6.70918 7.12836 6.05236 7.24908C5.39554 7.3698 5.01367 7.74704 4.55237 8.06392L5.25501 6.74508C5.2764 6.74508 5.29778 6.74207 5.31917 6.74207C5.31917 6.74207 5.31917 6.74207 5.32222 6.74207C5.34361 6.74207 5.36499 6.73905 5.38638 6.73905H5.38943C5.41082 6.73905 5.4322 6.73603 5.45664 6.73603H5.4597C5.48108 6.73603 5.50552 6.73301 5.52691 6.73301C6.73667 6.65153 8.37413 6.34068 9.07983 6.21091C9.08289 6.21091 9.08594 6.21091 9.089 6.21091C9.10122 6.20789 9.11344 6.20789 9.1226 6.20487C9.12566 6.20487 9.12871 6.20487 9.12871 6.20487C9.13788 6.20185 9.1501 6.20185 9.15926 6.19884C9.16232 6.19884 9.16537 6.19884 9.16843 6.19582C9.17759 6.1928 9.18676 6.1928 9.19592 6.18978C9.19898 6.18978 9.20509 6.18978 9.20814 6.18676C9.21425 6.18676 9.22342 6.18375 9.22953 6.18375C9.23258 6.18375 9.23869 6.18073 9.24175 6.18073C9.24786 6.18073 9.25396 6.17771 9.26007 6.17771C9.26313 6.17771 9.26924 6.17469 9.27229 6.17469C9.2784 6.17469 9.28146 6.17167 9.28757 6.17167C9.29062 6.17167 9.29673 6.16866 9.29979 6.16866C9.3059 6.16866 9.31201 6.16564 9.31812 6.16564C9.32117 6.16564 9.32423 6.16564 9.32728 6.16564C9.33645 6.16564 9.34256 6.16262 9.35172 6.16262C9.72443 6.10226 9.87107 6.4795 9.89551 6.92314C9.87412 7.29737 9.73359 7.69573 9.35172 7.83456C8.97596 7.97338 8.12057 8.51359 5.00145 8.51359",
    fill: "url(#paint4_linear_9478_22064)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.10955 6.71356C0.176759 6.3997 0.393661 6.14921 0.735818 6.16128C0.735818 6.16128 3.62276 6.74978 5.00361 6.74978C6.38445 6.74978 8.88036 6.24578 9.35082 6.16128C9.56773 6.12205 9.72964 6.25182 9.82129 6.45704C9.4272 6.35141 9.06366 6.451 8.69401 6.50834C8.20521 6.58379 8.06774 6.88559 7.54839 6.93086C7.02905 6.97613 6.11256 7.03648 5.83761 7.18738C5.56266 7.33828 4.79281 7.69741 4.64923 7.96299L3.91604 7.69741C3.91604 7.69741 2.70933 7.0063 2.35495 6.94595C2.00057 6.88559 0.961884 6.52343 0.47309 6.65924C0.329507 6.70149 0.207308 6.71356 0.10955 6.71356Z",
    fill: "url(#paint5_radial_9478_22064)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.19517 7.73899C0.943638 8.28222 2.4253 8.68662 5.00369 8.68662C7.58208 8.68662 9.06068 8.28222 9.81221 7.73899C9.82137 7.72993 9.83359 7.7239 9.84276 7.71484C9.90996 8.33352 9.745 8.86468 9.37229 9.13327C8.69103 9.62822 7.34685 9.9964 5.00369 9.9964C2.66053 9.9964 1.31634 9.62822 0.635086 9.13327C0.26238 8.86166 0.0974121 8.33352 0.164621 7.71484C0.173786 7.72088 0.186006 7.72993 0.19517 7.73899Z",
    fill: "url(#paint6_radial_9478_22064)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42148 5.61398C9.24429 5.57776 8.87769 5.65623 7.79318 5.86748C6.70867 6.07874 0.943944 5.8373 0.540689 5.70753C0.247412 5.61398 -0.0825243 6.26585 0.137433 6.46805C0.259632 6.5767 0.339061 6.39864 0.827856 6.49521C2.18732 6.76079 2.9755 6.90565 4.39911 8.07359C4.44494 8.1098 4.51215 8.10679 4.55186 8.06453C4.77487 7.83819 5.4714 7.15916 5.94492 7.02335C6.51926 6.85736 7.63432 6.97506 8.2056 6.58575C8.77382 6.19644 9.84001 6.56161 9.74836 6.12702C9.67198 5.76487 9.59866 5.65019 9.42148 5.61398Z",
    fill: "#FFCB4B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.62215 6.16155C2.19649 6.30641 3.98975 6.62933 4.5763 6.53879C5.16286 6.44826 6.9439 6.36375 7.30133 6.35168C7.65877 6.33961 7.9887 6.55388 7.24024 6.52371C6.49177 6.49353 5.74025 6.56897 5.45003 6.73496C5.1598 6.90095 4.81154 7.67052 4.73516 7.35364C4.65879 7.03675 4.50604 6.96131 4.0478 7.08202C3.58955 7.20274 3.51318 6.76514 2.99383 6.73496C2.47449 6.70478 2.04679 6.43317 1.38997 6.29736C0.733157 6.16155 0.629288 5.91106 1.62215 6.16155Z",
    fill: "url(#paint7_linear_9478_22064)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.208116 5.88057C0.299765 5.75382 0.425018 5.67233 0.541107 5.70855C0.944363 5.8353 6.70908 6.07976 7.7936 5.8685C8.87811 5.65724 9.24776 5.57576 9.42189 5.61499C9.5166 5.63612 9.58381 5.67837 9.63574 5.77193C9.48605 5.87454 9.22027 5.91377 9.12556 5.87454C8.7498 5.7176 8.6551 5.89868 8.51762 6.01336C8.38015 6.12804 8.34349 5.88661 8.16936 5.97715C7.99523 6.06768 7.77221 6.3393 7.66529 6.3393C7.55837 6.3393 7.26814 6.34534 7.17649 6.36948C7.08485 6.39362 6.76407 6.28498 6.67242 6.2548C6.58078 6.22462 6.5044 6.24876 6.5044 6.24876C6.5044 6.24876 6.27528 6.36344 6.25389 6.45398C6.23251 6.54452 6.05532 6.38759 6.00339 6.36948C5.95145 6.35137 5.73455 6.53547 5.59097 6.53547C5.44738 6.53547 5.39239 6.47511 5.16327 6.26989C5.08079 6.19746 4.62865 6.63506 4.58283 6.70145C4.537 6.76785 4.33232 6.55659 4.17957 6.457C4.02682 6.35741 3.93517 6.46605 3.7977 6.57168C3.66023 6.67731 3.69994 6.66825 3.5533 6.52641C3.40667 6.38457 3.10728 6.18237 3.06451 6.2216C3.02174 6.26083 3.03396 6.49925 2.86594 6.36646C2.74679 6.2729 2.46879 6.29101 2.3527 6.33628C2.23661 6.38155 2.12358 6.33025 2.1083 6.31516C2.09303 6.30007 1.79975 6.13106 1.55841 5.98016C1.49731 5.94395 0.816054 6.04958 0.672471 6.08881C0.528888 6.12804 0.360864 6.08881 0.360864 6.08881C0.360864 6.08881 0.28449 5.94697 0.208116 5.88057Z",
    fill: "url(#paint8_radial_9478_22064)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47345 5.07422C9.6262 5.16476 9.98363 5.26133 9.99891 5.30056C10.0142 5.3398 9.86754 5.42128 9.6873 5.57218C9.53455 5.69893 9.31459 5.7774 9.1985 5.7774C9.08242 5.7774 8.65472 5.74118 8.51725 5.85285C8.37977 5.96451 8.34006 5.83776 8.16593 5.9283C7.99179 6.01883 7.76878 6.17577 7.66186 6.17577C7.55493 6.17577 7.26471 6.1818 7.17306 6.20595C7.08141 6.23009 6.76064 6.12145 6.66899 6.09127C6.57734 6.06109 6.50097 6.08523 6.50097 6.08523C6.50097 6.08523 6.27185 6.19991 6.25046 6.29045C6.22908 6.38099 6.05189 6.22406 5.99995 6.20595C5.94802 6.18784 5.73112 6.37193 5.58753 6.37193C5.44395 6.37193 5.25149 6.32667 5.15984 6.26631C5.06819 6.20595 4.62522 6.47153 4.57939 6.53792C4.53357 6.60432 4.35027 6.50171 4.19752 6.40211C4.04478 6.30252 3.92869 6.30554 3.79427 6.40815C3.65985 6.51076 3.69651 6.50472 3.54987 6.36288C3.40323 6.22104 3.10385 6.12446 3.06108 6.16671C3.01831 6.20897 2.96943 6.31158 2.8625 6.20293C2.75558 6.09428 2.46536 6.12748 2.34927 6.17275C2.23318 6.21802 2.12015 6.16671 2.10487 6.15162C2.0896 6.13653 1.83298 6.05807 1.59164 5.91019C1.53054 5.87397 0.812621 5.88605 0.669038 5.92528C0.525455 5.96451 0.35743 5.92528 0.35743 5.92528C0.35743 5.92528 0.256618 5.72609 0.171079 5.68988C0.0824842 5.65366 0 5.55407 0 5.52389C0 5.49371 0.0610991 5.47862 0.106924 5.39714C0.152748 5.31565 0.262727 5.24322 0.326881 5.17985C0.391035 5.11647 2.88694 5.4575 2.88694 5.4575L6.80341 5.48164L8.67305 5.16476L9.47345 5.07422Z",
    fill: "url(#paint9_linear_9478_22064)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46479 4.80991C8.79167 5.04229 9.24992 5.20224 9.46376 5.33201C9.67761 5.46178 9.3324 5.47989 9.13383 5.49498C8.93526 5.51007 9.07273 5.70624 8.80695 5.65493C8.54116 5.60363 8.532 5.45876 8.26316 5.54025C7.99433 5.62173 8.40675 4.7918 8.4373 4.80085",
    fill: "url(#paint10_linear_9478_22064)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45524 5.84479C3.81572 5.96853 3.80656 6.07114 3.95931 6.16168C4.11205 6.25222 4.14871 5.99569 4.53058 6.06208C4.91245 6.12848 4.76276 5.89911 5.29432 6.09226C5.82589 6.28541 5.74646 6.14055 5.63648 6.06812C5.5265 5.99569 5.8045 5.86592 5.56927 5.78745C5.33404 5.70596 4.18537 5.5943 4.15788 5.60637C4.13038 5.61844 3.45524 5.84479 3.45524 5.84479Z",
    fill: "url(#paint11_linear_9478_22064)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93848 5.13281C8.84377 5.36519 8.78878 5.58248 8.74907 5.77865C8.65436 5.7877 8.56882 5.80883 8.51995 5.85108C8.59021 5.64284 8.62992 5.39537 8.63298 5.17205L8.67269 5.16601L8.93848 5.13281Z",
    fill: "url(#paint12_linear_9478_22064)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0.232246 5.26015C0.265851 5.23299 0.299456 5.20583 0.323895 5.18168C0.38805 5.1183 2.8809 5.45933 2.8809 5.45933L6.79737 5.48348L7.83301 5.30844C7.76885 5.59816 7.72608 5.92108 7.57945 6.1776C7.52751 6.1776 7.46336 6.18062 7.3992 6.18364C7.47252 6.08405 7.57639 6.04783 7.55195 5.83054C7.5214 5.54987 7.2434 5.30542 6.95318 5.77923C6.85847 5.93315 6.74849 6.01765 6.62324 6.08405C6.54992 6.06896 6.49493 6.08707 6.49493 6.08707C6.49493 6.08707 6.34829 6.1595 6.27803 6.23494C6.23526 6.25305 6.18943 6.27418 6.14667 6.29832C6.08862 6.26814 6.02141 6.21684 5.99086 6.20778C5.98475 6.20476 5.97253 6.20778 5.96031 6.2108C6.22915 5.91806 6.3544 5.56798 5.85033 5.78829C5.20879 6.06896 4.98578 5.81847 4.49698 6.26512C4.42061 6.33454 4.33812 6.39188 4.24953 6.44016C4.22814 6.42809 4.20676 6.413 4.18843 6.40093C4.15483 6.37981 4.12428 6.36472 4.09373 6.35264C4.3259 6.23796 4.66501 5.88184 4.36256 5.89995C3.9868 5.9241 2.99699 5.70379 2.36767 6.05085C2.28213 6.09914 2.19354 6.13535 2.11105 6.16251C2.10189 6.1595 2.09578 6.15346 2.09578 6.15044C2.0805 6.13535 1.84221 6.06292 1.60698 5.9241C1.61615 5.91806 1.62531 5.91504 1.63448 5.90901C2.13244 5.67361 1.21289 5.54685 0.779086 5.73397C0.433874 5.8909 0.0275631 5.55289 0.232246 5.26015Z",
    fill: "url(#paint13_linear_9478_22064)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0.506703 5.13722C0.72666 5.30019 0.326459 5.39676 0.292855 5.51144C0.25925 5.62613 0.360064 5.44807 0.796925 5.53559C1.23379 5.62311 1.3957 5.53559 1.61566 5.55671C1.83561 5.57784 1.23989 4.95312 1.14825 4.95312C1.0566 4.95312 0.506703 5.13722 0.506703 5.13722Z",
    fill: "url(#paint14_linear_9478_22064)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83554 5.617C1.84165 5.62002 1.85081 5.62605 1.85692 5.62907C2.10132 5.78902 2.13493 5.98518 2.28768 6.02743C2.44653 6.0727 2.25713 5.93086 2.33961 5.86749C2.4221 5.80109 2.10132 5.55664 2.10132 5.55664",
    fill: "url(#paint15_linear_9478_22064)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58373 5.1518C9.58373 5.1518 8.51755 5.99682 4.97379 5.99682C4.01453 5.99682 3.23857 5.93646 2.61536 5.84592C2.53898 5.83385 2.39234 5.84592 2.31902 5.83385C2.25487 5.8248 2.26709 5.7916 2.20904 5.77953C0.953453 5.55318 0.449384 5.22121 0.376064 5.16689C0.748771 5.16085 2.88114 5.45359 2.88114 5.45359L6.7976 5.47773L8.66724 5.16085L9.4707 5.07031C9.50125 5.08842 9.54402 5.10955 9.58984 5.12765C9.58984 5.13972 9.58679 5.14878 9.58373 5.1518Z",
    fill: "url(#paint16_radial_9478_22064)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0.366338 4.4114C0.366338 4.4114 1.43252 5.06931 4.97628 5.06931C8.52004 5.06931 9.58317 4.40234 9.58317 4.40234H9.60761C9.63205 4.6136 9.62289 5.01197 9.58317 5.09647C9.58317 5.09647 8.51699 5.8751 4.97323 5.8751C1.42947 5.8751 0.363282 5.10552 0.363282 5.10552C0.326623 5.02102 0.317458 4.62265 0.338843 4.4114H0.366338Z",
    fill: "url(#paint17_radial_9478_22064)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5649 4.35376C9.61378 4.3779 9.61378 4.44731 9.5649 4.47146C9.21053 4.65253 7.91522 5.18067 4.97634 5.18067C2.03747 5.18067 0.74216 4.64952 0.387784 4.47146C0.338904 4.44731 0.338904 4.3779 0.387784 4.35376C0.74216 4.17268 2.03747 3.64454 4.97634 3.64454C7.91522 3.64153 9.21053 4.17268 9.5649 4.35376Z",
    fill: "url(#paint18_radial_9478_22064)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0.164746 7.71484C0.173911 7.7239 0.186131 7.72993 0.195296 7.73899C0.259451 7.78727 0.332769 7.83254 0.409143 7.87781C0.577168 8.11321 0.687146 8.44518 1.08735 8.72887C1.77471 9.21174 2.82868 9.6252 5.00381 9.6252C8.76753 9.6252 9.2716 8.48743 9.55877 7.90196C9.65042 7.85065 9.7329 7.79633 9.80928 7.742C9.81844 7.73295 9.83066 7.72692 9.83983 7.71786C9.90704 8.33654 9.74207 8.8677 9.36936 9.13629C8.6881 9.63123 7.34392 9.99942 5.00076 9.99942C2.6576 9.99942 1.31341 9.63123 0.632156 9.13629C0.262506 8.86166 0.097537 8.33352 0.164746 7.71484Z",
    fill: "url(#paint19_linear_9478_22064)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0042 0.0625C1.37796 0.0625 0.0582123 2.40744 0.0582123 3.77456C0.0582123 4.91232 3.44922 4.94552 5.0042 4.94552C6.55918 4.94552 9.9502 4.90931 9.9502 3.77456C9.9502 2.40744 8.63045 0.0625 5.0042 0.0625Z",
    fill: "url(#paint20_linear_9478_22064)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M4.86365 0.0625C4.90947 0.0625 4.9553 0.0625 5.00418 0.0625C6.11008 0.0625 6.99907 0.279791 7.70477 0.620818C8.48379 1.61674 8.24245 2.70923 6.33309 2.18411C4.07241 1.56241 3.6325 1.08256 4.86365 0.0625Z",
    fill: "url(#paint21_radial_9478_22064)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37591 0.242188C1.49405 2.36983 5.37691 3.92709 7.41763 3.7279C9.37281 3.53777 9.2781 1.90809 7.43596 0.50173C9.24144 1.24414 9.9502 2.77122 9.9502 3.77317C9.9502 4.91094 6.55918 4.94413 5.0042 4.94413C3.44922 4.94413 0.0582123 4.90792 0.0582123 3.77317C0.0582123 2.63239 0.974702 0.815596 3.37591 0.242188Z",
    fill: "url(#paint22_linear_9478_22064)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0042 4.94863C3.44922 4.94863 0.0582123 4.91242 0.0582123 3.77767C0.0582123 2.81193 0.711975 1.36332 2.36777 0.59375C0.858613 2.54635 2.94821 3.94064 4.29851 4.11568C6.07955 4.34806 9.54694 4.64684 9.80661 2.92963C9.90437 3.23143 9.9502 3.52115 9.9502 3.77767C9.9502 4.91242 6.55918 4.94863 5.0042 4.94863Z",
    fill: "url(#paint23_linear_9478_22064)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13963 2.74337C7.13046 2.73432 7.11213 2.73734 7.10908 2.75243C7.09686 2.81882 7.06936 2.97274 7.08769 3.03008C7.10908 3.10553 7.17629 3.1508 7.23739 3.13571C7.29848 3.1176 7.32903 3.04215 7.30765 2.9667C7.29237 2.90936 7.18851 2.79468 7.13963 2.74337Z",
    fill: "url(#paint24_radial_9478_22064)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45821 2.33064C6.46431 2.34271 6.48263 2.34271 6.48568 2.33064C6.50704 2.26122 6.54977 2.1224 6.54672 2.06204C6.54367 1.97754 6.50704 1.91114 6.46126 1.91416C6.41548 1.91718 6.37886 1.98357 6.38191 2.06808C6.38496 2.12542 6.43379 2.26424 6.45821 2.33064Z",
    fill: "url(#paint25_radial_9478_22064)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32114 2.73145C5.3303 2.74352 5.34863 2.73749 5.34863 2.7224C5.34252 2.63488 5.32419 2.45682 5.29975 2.38741C5.26309 2.28782 5.20199 2.22142 5.15617 2.23651C5.1134 2.2516 5.10729 2.34214 5.1409 2.44173C5.16839 2.51114 5.2692 2.656 5.32114 2.73145Z",
    fill: "url(#paint26_radial_9478_22064)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86228 2.1383C8.8745 2.13227 8.8745 2.11416 8.85922 2.11114C8.7859 2.09002 8.63316 2.0538 8.569 2.05682C8.48041 2.06285 8.41015 2.10209 8.4132 2.15037C8.41625 2.19564 8.48957 2.22884 8.57817 2.22582C8.64232 2.21979 8.78896 2.16546 8.86228 2.1383Z",
    fill: "url(#paint27_radial_9478_22064)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65252 1.31212C7.66474 1.30306 7.65863 1.28495 7.64641 1.28495C7.56392 1.27892 7.38674 1.26685 7.31647 1.28495C7.22177 1.3091 7.15761 1.36946 7.16983 1.42076C7.18205 1.47207 7.27065 1.49319 7.36535 1.46905C7.43562 1.45396 7.58225 1.35738 7.65252 1.31212Z",
    fill: "url(#paint28_radial_9478_22064)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37301 1.19696C5.38828 1.19696 5.39439 1.17885 5.38217 1.1698C5.31802 1.11849 5.1836 1.00683 5.11333 0.979669C5.02168 0.946472 4.93309 0.958543 4.91476 1.00683C4.89643 1.05512 4.95447 1.12453 5.04612 1.15773C5.11333 1.18489 5.29052 1.19394 5.37301 1.19696Z",
    fill: "url(#paint29_radial_9478_22064)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32673 0.316279C6.32063 0.304207 6.30231 0.307225 6.29926 0.319297C6.28095 0.379655 6.24738 0.500373 6.25043 0.551678C6.25653 0.62109 6.29926 0.675413 6.34504 0.672395C6.39082 0.669377 6.42134 0.609019 6.41524 0.536588C6.41219 0.482265 6.3542 0.370601 6.32673 0.316279Z",
    fill: "url(#paint30_radial_9478_22064)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21447 0.309402C5.22669 0.315438 5.23891 0.303366 5.23585 0.288276C5.20836 0.224899 5.15031 0.0981461 5.1106 0.055895C5.05561 0.00157215 4.98229 -0.0165355 4.94868 0.0166618C4.91508 0.0498591 4.93035 0.12229 4.98534 0.17963C5.02506 0.221882 5.15337 0.28224 5.21447 0.309402Z",
    fill: "url(#paint31_radial_9478_22064)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87335 0.261371C3.86113 0.255335 3.84891 0.267407 3.85196 0.279479C3.87946 0.348891 3.94361 0.508842 3.98943 0.557129C4.05053 0.623524 4.13607 0.644649 4.17884 0.605416C4.22161 0.566183 4.20633 0.481681 4.14524 0.415286C4.09636 0.370017 3.94361 0.294568 3.87335 0.261371Z",
    fill: "url(#paint32_radial_9478_22064)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76684 1.44111C3.75462 1.43206 3.73934 1.44111 3.7424 1.4562C3.75462 1.53165 3.78516 1.69764 3.82182 1.758C3.86765 1.83344 3.94708 1.87268 3.99596 1.8425C4.04484 1.81232 4.04789 1.72782 3.99901 1.64935C3.96541 1.58899 3.82793 1.48638 3.76684 1.44111Z",
    fill: "url(#paint33_radial_9478_22064)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81894 2.84393C2.82199 2.83186 2.80672 2.81979 2.79755 2.82582C2.7334 2.86506 2.58676 2.9556 2.54399 3.00992C2.489 3.08235 2.48289 3.16685 2.52872 3.20005C2.57454 3.23325 2.65703 3.20307 2.71202 3.13365C2.75478 3.08235 2.80061 2.91636 2.81894 2.84393Z",
    fill: "url(#paint34_radial_9478_22064)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53869 1.99661C2.55091 1.99057 2.55091 1.97246 2.53869 1.96945C2.46842 1.94228 2.30956 1.87891 2.2393 1.87891C2.14765 1.87891 2.07433 1.92418 2.07433 1.98152C2.07433 2.03886 2.14765 2.08413 2.2393 2.08413C2.30651 2.08413 2.46842 2.02377 2.53869 1.99661Z",
    fill: "url(#paint35_radial_9478_22064)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58138 0.900501C2.58749 0.888429 2.57527 0.876357 2.56305 0.879375C2.48973 0.903519 2.32782 0.957841 2.27283 1.00009C2.20257 1.05743 2.17813 1.13892 2.21479 1.18419C2.25145 1.22946 2.33699 1.21738 2.40725 1.16004C2.46224 1.11477 2.54778 0.966895 2.58138 0.900501Z",
    fill: "url(#paint36_radial_9478_22064)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1.07466 2.39773C1.06855 2.4098 1.07772 2.42489 1.08994 2.41886C1.16326 2.40075 1.33128 2.3585 1.38627 2.31926C1.45959 2.26796 1.49319 2.18647 1.45959 2.1412C1.42598 2.09594 1.33739 2.09895 1.26407 2.15026C1.20908 2.19251 1.11438 2.33435 1.07466 2.39773Z",
    fill: "url(#paint37_radial_9478_22064)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07527 2.70813C4.09055 2.70813 4.09666 2.69304 4.08749 2.68398C4.03556 2.62966 3.91641 2.50894 3.85226 2.47876C3.76978 2.44255 3.68424 2.4516 3.6598 2.50592C3.63536 2.56025 3.68424 2.62966 3.76672 2.66587C3.82782 2.69304 3.9989 2.70209 4.07527 2.70813Z",
    fill: "url(#paint38_radial_9478_22064)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41307 2.14683C8.41307 2.13476 8.41613 2.12571 8.42224 2.11665C8.48639 2.17399 8.66664 2.19814 8.84077 2.10156C8.84688 2.10458 8.85604 2.10458 8.86215 2.1076C8.87743 2.11062 8.87743 2.13174 8.86521 2.13476C8.79189 2.16192 8.64831 2.21624 8.5811 2.21926C8.48945 2.22832 8.41307 2.19512 8.41307 2.14683Z",
    fill: "url(#paint39_linear_9478_22064)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6582 1.29688C7.6582 1.30291 7.6582 1.30895 7.65209 1.31196C7.58488 1.35723 7.43519 1.45381 7.36187 1.47192C7.26717 1.49606 7.17857 1.47493 7.16635 1.42363C7.16024 1.39948 7.17246 1.36931 7.19996 1.34516C7.24884 1.4025 7.25189 1.49304 7.36187 1.42363C7.46269 1.35723 7.56655 1.32404 7.6582 1.29688Z",
    fill: "url(#paint40_linear_9478_22064)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08684 3.02804C7.08379 3.01597 7.08073 2.99786 7.08073 2.97673C7.11434 3.022 7.14489 3.05822 7.16933 3.07331C7.22737 3.10349 7.3068 3.06425 7.29152 2.9375C7.29763 2.94957 7.30374 2.95863 7.30374 2.96768C7.32513 3.04313 7.29458 3.11858 7.23348 3.13668C7.17238 3.15479 7.10823 3.10349 7.08684 3.02804Z",
    fill: "url(#paint41_linear_9478_22064)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45821 2.24533C6.52536 2.2906 6.52536 2.08236 6.50399 1.9375C6.52841 1.96466 6.54367 2.00993 6.54672 2.06425C6.54977 2.12461 6.50704 2.26344 6.48568 2.33285C6.48263 2.34794 6.46126 2.34794 6.45821 2.33285C6.44905 2.30871 6.43685 2.27551 6.42464 2.23929C6.43379 2.23326 6.446 2.23628 6.45821 2.24533Z",
    fill: "url(#paint42_linear_9478_22064)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13173 2.25977C5.17145 2.29598 5.22032 2.41972 5.28142 2.56759C5.29975 2.61286 5.32114 2.63097 5.33947 2.63399C5.34252 2.66719 5.34558 2.70038 5.34863 2.72453C5.34863 2.73962 5.3303 2.74565 5.32114 2.73358C5.2692 2.66115 5.16839 2.51327 5.14395 2.44386C5.11646 2.36539 5.1134 2.29598 5.13173 2.25977Z",
    fill: "url(#paint43_linear_9478_22064)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91159 1.00781C4.93297 1.01385 4.95436 1.03196 4.97269 1.06214C5.02768 1.14664 5.1957 1.17078 5.36678 1.15871C5.37289 1.16173 5.37594 1.16776 5.379 1.17078C5.39121 1.17983 5.38205 1.19794 5.36983 1.19794C5.28735 1.19492 5.11016 1.18587 5.0399 1.16173C4.9513 1.12551 4.89326 1.05912 4.91159 1.00781Z",
    fill: "url(#paint44_linear_9478_22064)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30553 0.308594C6.31469 0.359899 6.29943 0.468544 6.28722 0.522867C6.27196 0.583226 6.3269 0.637549 6.40625 0.616423C6.39404 0.646602 6.37268 0.667728 6.34826 0.667728C6.30248 0.670746 6.25975 0.619441 6.25365 0.547011C6.24754 0.495706 6.28417 0.374988 6.30248 0.31463C6.29943 0.311612 6.30248 0.308594 6.30553 0.308594Z",
    fill: "url(#paint45_linear_9478_22064)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92736 0.0664062C5.00374 0.108657 5.11982 0.235411 5.22064 0.259554C5.22675 0.271626 5.2298 0.283698 5.23591 0.292752C5.24202 0.304823 5.22675 0.316895 5.21453 0.313877C5.15343 0.286716 5.02207 0.226357 4.98235 0.184106C4.94569 0.144873 4.92736 0.102622 4.92736 0.0664062Z",
    fill: "url(#paint46_linear_9478_22064)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85232 0.282668C3.84927 0.276632 3.85232 0.270596 3.85538 0.267578C3.9287 0.330955 4.00507 0.505995 4.04479 0.530139C4.0845 0.554282 4.13949 0.58748 4.20059 0.542211C4.20365 0.569372 4.19448 0.593516 4.17615 0.611623C4.13338 0.650856 4.0509 0.629731 3.98674 0.563336C3.94397 0.509013 3.87982 0.35208 3.85232 0.282668Z",
    fill: "url(#paint47_linear_9478_22064)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03223 1.77214C4.02917 1.80232 4.01695 1.82646 3.99557 1.83853C3.94669 1.86871 3.86726 1.82948 3.82143 1.75403C3.78477 1.69367 3.75423 1.52769 3.74201 1.45224C3.74201 1.44922 3.74201 1.44922 3.74201 1.44922C3.80616 1.5126 3.84282 1.67255 3.87948 1.7329C3.91614 1.78723 3.95891 1.81741 4.03223 1.77214Z",
    fill: "url(#paint48_linear_9478_22064)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62413 3.12797C2.673 3.11589 2.77687 2.965 2.80437 2.82617C2.81353 2.82617 2.81964 2.83523 2.81659 2.84428C2.79826 2.91671 2.74938 3.07968 2.70966 3.134C2.65468 3.20643 2.57525 3.23661 2.52637 3.2004C2.49582 3.17927 2.48971 3.134 2.50193 3.08571C2.53553 3.15513 2.5783 3.14004 2.62413 3.12797Z",
    fill: "url(#paint49_linear_9478_22064)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07445 1.98174C2.07445 1.9757 2.07445 1.96967 2.0775 1.96363C2.09278 1.96061 2.11111 1.96665 2.13555 1.98476C2.21192 2.03304 2.38301 2.02097 2.53576 1.97269C2.54798 1.97872 2.54798 1.99683 2.53576 1.99985C2.46549 2.02701 2.30358 2.08737 2.23637 2.08737C2.14777 2.08435 2.07445 2.03908 2.07445 1.98174Z",
    fill: "url(#paint50_linear_9478_22064)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55389 0.882393C2.55694 0.882393 2.56 0.879375 2.56305 0.879375C2.57527 0.876357 2.58749 0.888429 2.58138 0.900501C2.54472 0.966895 2.46224 1.11477 2.40725 1.16004C2.33699 1.21738 2.25145 1.22946 2.21479 1.18419C2.19951 1.16608 2.19646 1.13892 2.20257 1.11176C2.24228 1.12986 2.29422 1.16004 2.33699 1.16306C2.40114 1.1691 2.4714 1.00311 2.55389 0.882393Z",
    fill: "url(#paint51_linear_9478_22064)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1.07551 2.39698C1.07857 2.39094 1.08468 2.38491 1.08773 2.37585C1.16716 2.38491 1.27408 2.32153 1.35046 2.24306C1.39323 2.1978 1.43905 2.19176 1.47266 2.17969C1.47266 2.22496 1.44211 2.27928 1.38712 2.31549C1.32907 2.35473 1.1641 2.39698 1.09079 2.41509C1.07857 2.42414 1.0694 2.40905 1.07551 2.39698Z",
    fill: "url(#paint52_radial_9478_22064)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07527 2.70813C4.09055 2.70813 4.09666 2.69304 4.08749 2.68398C4.03556 2.62966 3.91641 2.50894 3.85226 2.47876C3.76978 2.44255 3.68424 2.4516 3.6598 2.50592C3.63536 2.56025 3.68424 2.62966 3.76672 2.66587C3.82782 2.69304 3.9989 2.70209 4.07527 2.70813Z",
    fill: "url(#paint53_radial_9478_22064)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72407 2.56657C3.77906 2.65711 3.93487 2.69031 4.06929 2.66616C4.0754 2.6722 4.08151 2.67823 4.08456 2.68427C4.09373 2.69332 4.08762 2.71143 4.07234 2.70841C3.99597 2.7054 3.82489 2.69332 3.76379 2.66616C3.6813 2.62995 3.63548 2.55752 3.65686 2.50621C3.65992 2.50319 3.66297 2.50018 3.66297 2.49414C3.68741 2.50923 3.70574 2.53337 3.72407 2.56657Z",
    fill: "url(#paint54_linear_9478_22064)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97671 4.53135C10.7017 4.53135 9.80661 2.92882 9.38197 2.05664C9.77606 2.65117 9.9502 3.27891 9.9502 3.77385C9.9502 4.91161 6.55918 4.94481 5.0042 4.94481L4.97671 4.53135Z",
    fill: "url(#paint55_linear_9478_22064)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00391 4.94925C3.44893 4.94925 0.0579157 4.91304 0.0579157 3.77829C0.0579157 3.29542 0.222884 2.68882 0.59559 2.10938C0.552821 2.19086 -0.647781 4.5358 4.97641 4.5358L5.00391 4.94925Z",
    fill: "url(#paint56_linear_9478_22064)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70645 6.71883C3.61683 7.06589 4.24005 8.09501 4.64941 7.96222C4.6097 8.00145 4.57609 8.03465 4.5486 8.06181C4.50889 8.10406 4.44168 8.10708 4.39585 8.07086C2.97224 6.90292 2.18406 6.75806 0.824595 6.49248C0.3358 6.39591 0.256371 6.57698 0.134172 6.46532C0.0577979 6.39591 0.0486331 6.27519 0.0791831 6.14844C1.09343 6.54379 1.46919 6.25105 2.70645 6.71883Z",
    fill: "#FFBC47"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94492 7.02059C5.60888 7.11716 5.16591 7.48233 4.8543 7.76903C4.94289 7.53364 5.17507 7.14734 5.74024 6.91194C6.38178 6.64636 7.41436 6.80329 7.88483 6.60109C8.09867 6.50754 8.62413 6.12426 9.07932 6.20574C9.41842 6.2661 9.65365 6.13935 9.70559 5.94922C9.72086 6.00052 9.73308 6.05786 9.74836 6.12426C9.84001 6.55884 8.77382 6.19669 8.2056 6.58299C7.63432 6.9723 6.51926 6.8546 5.94492 7.02059Z",
    fill: "url(#paint57_linear_9478_22064)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0.635211 9.13327C0.262506 8.86166 0.097537 8.33352 0.164746 7.71484C0.173911 7.7239 0.186131 7.72993 0.195296 7.73899C0.219736 7.75709 0.247231 7.7752 0.274726 7.79331C0.143362 9.08197 1.82665 9.84249 5.34902 9.84249C8.7492 9.84249 9.50989 9.18458 9.80011 7.74502C9.80317 7.74201 9.80622 7.73899 9.80928 7.73899C9.81844 7.72993 9.83066 7.7239 9.83983 7.71484C9.90704 8.33352 9.74207 8.86468 9.36936 9.13327C8.6881 9.62822 7.34392 9.9964 5.00076 9.9964C2.66065 9.9964 1.31647 9.62822 0.635211 9.13327Z",
    fill: "url(#paint58_linear_9478_22064)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29118 5.89354C8.36144 5.88146 8.45615 5.85732 8.5814 5.73358C8.70665 5.60985 9.1985 5.77885 9.42152 5.61588C9.61092 5.47706 9.73312 5.29296 9.91948 5.25977C9.9653 5.27787 9.99585 5.29296 9.99891 5.30503C10.0142 5.34125 9.86754 5.42575 9.6873 5.57665C9.53455 5.7034 9.31459 5.78187 9.1985 5.78187C9.08242 5.78187 8.65472 5.74566 8.51725 5.85732C8.41949 5.93579 8.37366 5.89052 8.29118 5.89354Z",
    fill: "url(#paint59_linear_9478_22064)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0.32072 5.82612C0.424589 5.92873 1.03864 5.8563 1.35024 5.75671C1.66185 5.65711 2.15981 6.15507 2.22091 6.143C2.48975 6.09773 2.69443 6.03737 2.82274 6.143C2.95105 6.24863 2.96021 6.11886 3.0427 6.09773C3.12518 6.07661 3.54677 6.0917 3.61398 6.2939C3.64758 6.39349 3.69646 6.40858 3.76367 6.43876C3.66591 6.51421 3.68424 6.4961 3.55288 6.36633C3.40624 6.22147 3.10685 6.12791 3.06408 6.17016C3.02131 6.21241 2.97243 6.31502 2.86551 6.20638C2.75859 6.09773 2.46836 6.13093 2.35228 6.1762C2.23619 6.22147 2.12315 6.17016 2.10788 6.15507C2.0926 6.13998 1.83599 6.06152 1.59464 5.91364C1.53354 5.87742 0.815625 5.8895 0.672042 5.92873C0.528458 5.96796 0.360435 5.92873 0.360435 5.92873C0.360435 5.92873 0.25962 5.72955 0.174081 5.69333C0.0854869 5.65711 0.00300336 5.55752 0.00300336 5.52734C0.287116 5.67522 0.213796 5.72049 0.32072 5.82612Z",
    fill: "url(#paint60_linear_9478_22064)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85438 6.25205C5.12933 5.96534 5.37373 6.31241 5.50204 6.31844C5.74643 6.3275 5.92973 5.91102 6.11914 6.27921C6.07026 6.24903 6.02444 6.21583 6 6.2098C5.94501 6.19471 5.73116 6.37578 5.58758 6.37578C5.44399 6.37578 5.25153 6.33051 5.15988 6.27016C5.06823 6.2098 4.62526 6.47537 4.57944 6.54177C4.54889 6.58704 4.45418 6.55384 4.35031 6.4965C4.47557 6.50254 4.59166 6.52668 4.85438 6.25205Z",
    fill: "url(#paint61_linear_9478_22064)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44594 6.00963C6.34819 5.97342 6.08546 5.86779 6.26876 5.87986C6.45205 5.88892 7.0325 6.22693 7.16081 6.1545C7.28912 6.08207 7.57934 6.19675 7.70459 6.06999C7.8329 5.94324 8.16895 5.92513 8.16895 5.92513C7.99176 6.01567 7.7718 6.1726 7.66488 6.1726C7.55795 6.1726 7.26773 6.17864 7.17608 6.20278C7.08443 6.22693 6.76366 6.11828 6.67201 6.0881C6.58036 6.05792 6.50399 6.08207 6.50399 6.08207C6.50399 6.08207 6.27487 6.19675 6.25348 6.28729C6.25959 6.09112 6.54065 6.04585 6.44594 6.00963Z",
    fill: "url(#paint62_linear_9478_22064)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07087 9.13434C8.19613 9.00457 8.26945 8.68467 8.25417 8.37986C8.95682 8.21387 9.46394 7.99054 9.81221 7.73703C9.82137 7.72798 9.83359 7.72194 9.84276 7.71289C9.90996 8.33157 9.745 8.86273 9.37229 9.13132C8.69103 9.62626 7.34685 9.99445 5.00369 9.99445C6.65031 9.99747 7.5943 9.62928 8.07087 9.13434Z",
    fill: "url(#paint63_linear_9478_22064)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0.164842 7.7168C0.174007 7.72585 0.186227 7.73189 0.195392 7.74094C0.543658 7.99445 1.05078 8.21778 1.75342 8.38376C1.73509 8.68858 1.81147 9.00848 1.93672 9.13825C2.41635 9.6332 3.36034 10.0014 5.00391 10.0014C2.66075 10.0014 1.31656 9.6332 0.635306 9.13825C0.262601 8.86362 0.0976329 8.33548 0.164842 7.7168Z",
    fill: "url(#paint64_linear_9478_22064)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9478_22064",
    x1: 6.29763,
    y1: 6.24678,
    x2: 2.3631,
    y2: 11.0221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89043",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-6.74658 -0.14478 -0.0385816 1.75452 4.99804 7.33162)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2426,
    stopColor: "#643800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5E3500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7652,
    stopColor: "#4E2C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9478_22064",
    x1: 2.29758,
    y1: 7.33697,
    x2: -0.156749,
    y2: 7.33697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8063,
    stopColor: "#512D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8662,
    stopColor: "#4B2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9402,
    stopColor: "#3C2200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9478_22064",
    x1: 5.002,
    y1: 6.07072,
    x2: 5.02188,
    y2: 8.86736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#643800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3002,
    stopColor: "#5E3500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#4E2C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9478_22064",
    x1: 6.66466,
    y1: 7.50034,
    x2: 14.1116,
    y2: 5.98649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.42152 0.00781022 0.0015371 1.42526 4.96543 6.50092)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#512D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.0442 9.04588) rotate(180) scale(6.75507 1.58622)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9478_22064",
    x1: 4.25649,
    y1: 6.43677,
    x2: 4.8733,
    y2: 3.55656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00293411,
    stopColor: "#FFD65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5303,
    stopColor: "#FFD255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB4B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.92263 6.15852) rotate(180) scale(3.3572 3.31651)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9478_22064",
    x1: 4.02342,
    y1: 8.00819,
    x2: 5.36897,
    y2: 4.34576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9478_22064",
    x1: 8.452,
    y1: 4.9347,
    x2: 9.14388,
    y2: 5.84823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9478_22064",
    x1: 4.53878,
    y1: 5.02762,
    x2: 4.59841,
    y2: 6.28014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9478_22064",
    x1: 8.57323,
    y1: 7.16315,
    x2: 8.79687,
    y2: 4.68795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9478_22064",
    x1: 3.87983,
    y1: 6.73963,
    x2: 4.10347,
    y2: 4.26442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9478_22064",
    x1: 1.56489,
    y1: 4.66195,
    x2: 0.776037,
    y2: 5.80271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9478_22064",
    x1: 2.30395,
    y1: 5.5293,
    x2: 2.0702,
    y2: 5.86734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.98529 5.53679) rotate(180) scale(4.63012 0.583642)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#4B8C1C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B8C1C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.39667 5.31976) rotate(180) scale(5.92 1.26673)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2904,
    stopColor: "#E74939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9631,
    stopColor: "#BD2719"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.58717 3.94895) rotate(180) scale(6.41892 2.04945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#F78174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6656,
    stopColor: "#E74939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9631,
    stopColor: "#BD2719"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_9478_22064",
    x1: 4.99807,
    y1: 8.06524,
    x2: 4.77942,
    y2: 11.6066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#C86F34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_9478_22064",
    x1: 5.16383,
    y1: 2.6608,
    x2: 5.77533,
    y2: -1.44579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA25F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4407,
    stopColor: "#F3A968",
    stopOpacity: 0.9868
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB87A",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.0998 -0.376541 -0.213843 1.16357 6.16721 0.948654)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD2A8",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD2A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_9478_22064",
    x1: 5.84334,
    y1: -0.483687,
    x2: 4.61986,
    y2: 5.73898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#E89043",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89043",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_9478_22064",
    x1: 5.48955,
    y1: 0.0670628,
    x2: 4.77373,
    y2: 5.58209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89043",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89043",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-0.164885 0 1.40791e-06 0.162888 7.19956 2.93695)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.46583 2.12671) rotate(180) scale(0.164044 0.162211)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.2344 2.48437) rotate(180) scale(0.197949 0.19555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-0.167481 0.0381368 0.0386045 0.165452 8.63612 2.12512)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.41246 1.3791) rotate(180) scale(0.189115 0.186822)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.14845 1.07943) rotate(180) scale(0.188898 0.186608)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.33332 0.488736) rotate(180) scale(0.14267 0.141077)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.08236 0.156818) rotate(180) scale(0.155789 0.1539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.02749 0.444741) rotate(180) scale(0.180688 0.178499)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.88965 1.64462) rotate(180) scale(0.180108 0.177925)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.65992 3.02216) rotate(180) scale(0.180465 0.178279)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.31162 1.98109) rotate(180) scale(0.183215 0.180996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.39152 1.04401) rotate(180) scale(0.180548 0.17836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.27336 2.26592) rotate(180) scale(0.180279 0.178095)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.87211 2.58149) rotate(180) scale(0.179094 0.176925)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_9478_22064",
    x1: 8.87066,
    y1: 2.16304,
    x2: 8.4118,
    y2: 2.16304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_9478_22064",
    x1: 7.658,
    y1: 1.38989,
    x2: 7.16568,
    y2: 1.38989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_9478_22064",
    x1: 7.20409,
    y1: 2.78011,
    x2: 7.19415,
    y2: 3.17748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_9478_22064",
    x1: 6.54863,
    y1: 2.13999,
    x2: 6.42542,
    y2: 2.13999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_9478_22064",
    x1: 5.34861,
    y1: 2.49879,
    x2: 5.12024,
    y2: 2.49879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_9478_22064",
    x1: 5.38738,
    y1: 1.10352,
    x2: 4.90928,
    y2: 1.10352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_9478_22064",
    x1: 6.40456,
    y1: 0.488324,
    x2: 6.24995,
    y2: 0.488324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_9478_22064",
    x1: 5.23684,
    y1: 0.189623,
    x2: 4.92847,
    y2: 0.189623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_9478_22064",
    x1: 4.20268,
    y1: 0.447743,
    x2: 3.85258,
    y2: 0.447743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_9478_22064",
    x1: 4.03354,
    y1: 1.65021,
    x2: 3.74373,
    y2: 1.65021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_9478_22064",
    x1: 2.82127,
    y1: 3.02256,
    x2: 2.5003,
    y2: 3.02256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_9478_22064",
    x1: 2.54875,
    y1: 2.02291,
    x2: 2.07472,
    y2: 2.02291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_9478_22064",
    x1: 2.58386,
    y1: 1.04401,
    x2: 2.19968,
    y2: 1.04401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.27415 2.30167) rotate(180) scale(0.165381 0.163375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_9478_22064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.87211 2.58149) rotate(180) scale(0.179094 0.176925)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_9478_22064",
    x1: 4.09134,
    y1: 2.60017,
    x2: 3.65313,
    y2: 2.60017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#FFE8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_9478_22064",
    x1: 6.46258,
    y1: 2.11936,
    x2: 9.81935,
    y2: 8.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#C86F34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_9478_22064",
    x1: 3.92425,
    y1: 1.61073,
    x2: -0.185166,
    y2: 8.77658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#C86F34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_9478_22064",
    x1: 6.74791,
    y1: 8.4657,
    x2: 7.9134,
    y2: 5.29336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_9478_22064",
    x1: 5.02243,
    y1: 7.54687,
    x2: 4.84354,
    y2: 11.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#C86F34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_9478_22064",
    x1: 10.002,
    y1: 5.58102,
    x2: 8.2895,
    y2: 5.58102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B8C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_9478_22064",
    x1: 1.65668,
    y1: 6.56608,
    x2: 1.9504,
    y2: 5.76659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B8C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_9478_22064",
    x1: 5.22504,
    y1: 6.71433,
    x2: 5.24491,
    y2: 5.93972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B8C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_9478_22064",
    x1: 6.94586,
    y1: 6.54466,
    x2: 7.29108,
    y2: 5.60504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B8C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_9478_22064",
    x1: 7.88537,
    y1: 9.11731,
    x2: 9.34287,
    y2: 9.96257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#C86F34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_9478_22064",
    x1: 2.1098,
    y1: 9.14213,
    x2: -0.0144703,
    y2: 10.4528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0582123,
    stopColor: "#C86F34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.bf74960df51214653c33ce8f92a7baf1.svg";
export { ForwardRef as ReactComponent };